/*
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import View from './View';

import fontVertexShader from '../shaders/Font/Font.vert';
import fontFragmentShader from '../shaders/Font/Font.frag';

import createFont from 'three-bmfont-text';
import loadFont from 'load-bmfont';

import { font16, font24, font32, font48, font56, font64 } from '../fonts/fonts';

import vertexShader from '../shaders/Toast/Toast.vert';
import fragmentShader from '../shaders/Toast/Toast.frag';

export default class Toast extends View {
  constructor(props) {
    super(props);
    this.props.vertexShader = vertexShader;
    this.props.fragmentShader = fragmentShader;
  }

  setup = () => {
    this.setupText();
    this.setupMaterial();
    this.setupGeometry();
    this.setupMesh();
    this.setupEvents();
    this.fadeOut(0);
  };

  createText = (font, text, alpha) => {
    let geometry = createFont({
      text: text,
      align: 'center',
      font: font.font,
    });

    let material = new THREE.RawShaderMaterial({
      side: THREE.DoubleSide,
      transparent: true,
      uniforms: {
        textAlpha: {
          value: 1.0,
        },
        textColor: {
          value: new THREE.Color(0xffffff),
        },
        map: {
          value: font.texture,
        },
        alpha: alpha,
      },
      vertexShader: fontVertexShader,
      fragmentShader: fontFragmentShader,
    });

    let mesh = new THREE.Mesh(geometry, material);
    var layout = geometry.layout;
    this.props.width = layout.width + 100;
    mesh.position.set(-layout.width * 0.5, -layout.lineHeight * 0.25, 0);
    mesh.scale.set(1, -1, 1);
    return mesh;
  };

  setupMaterial = () => {
    this.startTime = Date.now();
    this.material = new THREE.RawShaderMaterial({
      uniforms: {
        backgroundColor: {
          value: this.props.backgroundColor,
        },
        backgroundAlpha: {
          value: this.props.backgroundAlpha,
        },
        size: {
          value: new THREE.Vector2(this.props.width, this.props.height),
        },
        radius: {
          value: Math.min(this.props.width, this.props.height),
        },
        alpha: this.alpha,
        time: {
          value: 0.0,
        },
      },
      vertexShader: this.props.vertexShader,
      fragmentShader: this.props.fragmentShader,
      depthTest: false,
      depthWrite: false,
      transparent: true,
    });
  };

  setupText = () => {
    this.alphaTween.onUpdate(this.onAlphaUpdate);
    this.text = this.createText(font64, this.props.text, this.alpha);
    this.text.renderOrder = 2;
    this.add(this.text);
  };

  onAlphaUpdate = event => {
    this.text.material.uniforms.alpha.value =
      this.props.textAlpha * this.alpha.value;
  };

  dismiss = (duration, delay, cb) => {
    this.fadeOut(duration, delay, cb);
  };

  spawn = (duration, delay, cb) => {
    this.fadeIn(duration, delay, cb);
  };
}



// WEBPACK FOOTER //
// ./src/hud/Toast.js